<template>
    <div class="accept-task">
      <custom-price-input v-if="$u.checkPermissions('task.accept')"
                          :label="$t('tasks.general.labels.acceptedTime')"
                          :checkbox-label="$t('global.confirm')"
                          :change-value-with-checkbox="false"
                          :has-digit="true"
                          :currency="$t('tasks.general.labels.hour')"
                          @pressEnter="acceptTask"
                          v-model="task.acceptedTime" />

      <button id="acceptTaskBtn" v-show="false" @click="acceptTask"></button>
    </div>
</template>

<script>
import {acceptTask, getCategories, getTask} from '../../../http/requests/tasks'
import Datepicker from 'vue-persian-datetime-picker'
import CustomSelect from '../../../components/select/customSelect.vue'
import CustomValidateTextarea from '@/components/input/customValidateTextarea.vue'
import CustomFileInput from '@/components/input/customeFileInput.vue'
import CustomPriceInput from '@/components/input/customPriceInput.vue'

export default {
  name: 'AcceptTask',
  components: {
    CustomPriceInput,
    CustomFileInput,
    CustomValidateTextarea,
    Datepicker,
    CustomSelect
  },

  model: {
    prop: 'userTask',
    event: 'change'
  },

  props: {
    userId: {
      type: [Number, String],
      default: 0
    },
    taskId: {
      type: [Number, String],
      default: 0
    }
  },

  data () {
    return {
      task: {
        id: 0,
        description: {
          value: '',
          isValid: true
        },
        startTime: '',
        endTime: '',
        category: {
          label: '-',
          value: ''
        },
        attachment: {
          value: '',
          isValid: true
        },
        acceptedTime: {
          value: '',
          checked: false,
          isValid: false
        }
      },
      categories: []
    }
  },

  created () {
    this.getCategoriesList()
    this.getTask()
  },

  methods: {
    getTask () {
      getTask(this.taskId, true).then((response) => {
        const taskInfo = response.data.data
        this.task.id = taskInfo.id
        this.task.description.value = taskInfo.description
        this.task.attachment.value = taskInfo.attachment
        this.task.startTime = taskInfo.started_at.split(' ')[1]
        this.task.endTime = taskInfo.finished_at.split(' ')[1]
        this.task.category = {
          label: taskInfo.category.name,
          value: taskInfo.category.id,
          id: taskInfo.category.id
        }
        this.task.acceptedTime = {
          value: taskInfo.accepted_time || '',
          checked: false,
          isValid: true
        }
      })
    },
    getCategoriesList () {
      getCategories()
        .then((response) => {
          const categories = response.data.data.children
          for (let i = 0; i < categories.length; i++) {
            if (categories[i].id > 0) {
              this.categories.push({
                id: categories[i].id ? categories[i].id : '',
                value: categories[i].id ? categories[i].id : '',
                label: categories[i].name ? categories[i].name : ''
              })
            }
          }
        })
    },
    acceptTask () {
      // eslint-disable-next-line no-unused-vars
      let task = {}
      const userTask = this.task
      if (userTask.acceptedTime.value.length > 0) {
        task = {
          accepted_time: userTask.acceptedTime.value || ''
        }

        if (this.$u.checkPermissions('task.accept')) {
          task.accepted_time = this.$u.parseFloat(userTask.acceptedTime.value || '0')
        }

        acceptTask(this.taskId, task)
          .then(() => {
            this.$vs.notify({
              time: 2500,
              title: this.$t('alert.message.title'),
              text: this.$t('tasks.general.notification.accept.success'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
            this.$emit('edited')
          })
          .catch((e) => {
            this.$vs.notify({
              time: 2500,
              title: this.$t('alert.error.title'),
              text: e.response.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })

      }
    }
  }
}
</script>

<style lang="scss">

.accept-task {
  .fields-label {
    font-size: 12px;
    margin-bottom: 5px;
  }

  .vpd-input-group {
    .vpd-icon-btn {
      position: absolute;
      border-radius: .5rem 0 0 .5rem !important;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 40px;
    }

    input {
      border-radius: .5rem;
      line-height: 40px;
      height: 40px;
      padding: 0 50px;
    }
  }
}
</style>
